// Convert a hex colour to HSL component parts {h, s, l}
export function hexToHslParts(hex) {
  if (!hex) return null;
  let h = hex.replace("#", "").trim();
  if (h.length === 3) h = h.split("").map((c) => c + c).join("");
  if (h.length !== 6) return null;
  const r = parseInt(h.slice(0, 2), 16) / 255;
  const g = parseInt(h.slice(2, 4), 16) / 255;
  const b = parseInt(h.slice(4, 6), 16) / 255;
  const max = Math.max(r, g, b), min = Math.min(r, g, b);
  let hue, sat, lum = (max + min) / 2;
  if (max === min) { hue = 0; sat = 0; }
  else {
    const d = max - min;
    sat = lum > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r: hue = (g - b) / d + (g < b ? 6 : 0); break;
      case g: hue = (b - r) / d + 2; break;
      default: hue = (r - g) / d + 4;
    }
    hue /= 6;
  }
  return { h: Math.round(hue * 360), s: Math.round(sat * 100), l: Math.round(lum * 100) };
}

// Build the CSS custom-property overrides so Tailwind's bg-brand / text-brand / bg-accent adopt the colour
export function brandVars(hex) {
  const p = hexToHslParts(hex);
  if (!p) return null;
  const { h, s, l } = p;
  // Keep the brand colour dark enough that white button text stays readable.
  const bl = Math.min(l, 52);
  return {
    "--brand": `${h} ${s}% ${bl}%`,
    "--brand-hover": `${h} ${s}% ${Math.max(0, bl - 8)}%`,
    "--accent": `${h} ${Math.min(70, s)}% 92%`,
    "--accent-foreground": `${h} ${s}% ${Math.max(20, bl - 6)}%`,
    "--ring": `${h} ${s}% ${bl}%`,
  };
}
